import { ShieldCheck, Lock, Landmark, BadgeCheck } from "lucide-react";

const items = [
  { icon: Lock, title: "Data 100% Sulit", desc: "Maklumat & dokumen anda dirahsiakan" },
  { icon: ShieldCheck, title: "Penghantaran Selamat", desc: "Muat naik dokumen dengan selamat" },
  { icon: Landmark, title: "Bank Utama", desc: "Kerjasama dengan bank terkemuka" },
  { icon: BadgeCheck, title: "Perunding Berdaftar", desc: "Bimbingan profesional & telus" },
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="border-y border-slate-200 bg-[#F8F9FA]">
      <div className="mx-auto max-w-7xl px-6 py-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((it) => (
            <div key={it.title} className="flex items-start gap-3">
              <div className="shrink-0 rounded-xl bg-white border border-slate-200 p-2.5">
                <it.icon className="h-5 w-5 text-[#0A2540]" />
              </div>
              <div>
                <p className="font-heading font-bold text-[#0A2540] text-sm">{it.title}</p>
                <p className="text-xs text-slate-500 mt-0.5">{it.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
